document.addEventListener('DOMContentLoaded', () => {
  const sticky = document.getElementById('StickyATC');
  const stickyButton = document.getElementById('StickyATCButton');
  const stickyPrice = document.getElementById('StickyATCPrice');
  const stickyVariant = document.getElementById('StickyATCVariant');
  const menuDrawer = document.getElementById('Details-menu-drawer-container');

  if (!sticky || !stickyButton || !stickyPrice) return;

  const mainButton = document.querySelector('button[name="add"]');
  sticky.classList.remove('visible');
  sticky.classList.add('hidden');
  const variantJson = document.querySelector('variant-selects script[type="application/json"]');

  if (!mainButton) return;

  const variants = variantJson ? JSON.parse(variantJson.textContent) : [];

  function isSoldOut() {
    // Controleer of de huidige variant uitverkocht is via window.productVariants
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && window.productVariants) {
      const v = window.productVariants.find(function(pv) {
        return String(pv.id) === String(idInput.value);
      });
      if (v) return !v.available;
    }
    // Fallback: kijk of de mainButton disabled is
    return mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
  }

  function getCurrentVariant() {
    const selectedRadio = document.querySelector('input[type="radio"]:checked');

    if (!variantJson) {
      return { title: '', available: !mainButton.disabled, price: null };
    }

    if (!selectedRadio) {
      return { title: '', available: !mainButton.disabled, price: null };
    }

    return { title: selectedRadio.value, available: !mainButton.disabled, price: null };
  }

  function syncSticky() {
    const currentVariant = getCurrentVariant();
    if (!currentVariant) return;

    const livePrice = document.querySelector('.price .price-item');
    if (livePrice) {
      stickyPrice.textContent = livePrice.textContent.replace(' Incl. BTW', '').trim();
    }

    if (stickyVariant) {
      stickyVariant.textContent = currentVariant.title || '';
    }

    const soldOut = isSoldOut();
    if (soldOut) {
      stickyButton.disabled = true;
      stickyButton.textContent = 'Uitverkocht';
    } else {
      stickyButton.disabled = false;
      stickyButton.textContent = 'Toevoegen';
    }

    // Herbereken zichtbaarheid na sync (variant kan gewijzigd zijn)
    updateStickyVisibility();
  }

  stickyButton.addEventListener('click', () => {
    if (stickyButton.disabled) return;
    mainButton.click();
  });

  function updateStickyVisibility() {
    // Nooit tonen als variant uitverkocht is
    if (isSoldOut()) {
      sticky.classList.remove('visible');
      sticky.classList.add('hidden');
      return;
    }

    const rect = mainButton.getBoundingClientRect();
    if (rect.bottom <= 0) {
      sticky.classList.remove('hidden');
      sticky.classList.add('visible');
    } else {
      sticky.classList.remove('visible');
      sticky.classList.add('hidden');
    }
  }

  window.addEventListener('scroll', updateStickyVisibility);
  window.addEventListener('resize', updateStickyVisibility);

  syncSticky();

  requestAnimationFrame(() => {
    updateStickyVisibility();
  });

  window.addEventListener('load', () => {
    updateStickyVisibility();
  });

  if (menuDrawer) {
    menuDrawer.addEventListener('toggle', () => {
      if (menuDrawer.open) {
        sticky.classList.remove('visible');
      } else {
        updateStickyVisibility();
      }
    });
  }

  document.addEventListener('change', () => {
    setTimeout(syncSticky, 150);
  });

  // Luister ook op variant-change zodat het direct reageert
  function trySubscribeStickyAtc(attempts) {
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function() {
        setTimeout(syncSticky, 50);
      });
    } else if (attempts > 0) {
      setTimeout(function() { trySubscribeStickyAtc(attempts - 1); }, 100);
    }
  }
  trySubscribeStickyAtc(20);

});
